export enum AuthStatus {
  INITIALIZING = "initializing",
  SIGNED_OUT = "signedOut",
  LOADING_CLAIMS = "loadingClaims",
  NEEDS_TENANT = "needsTenant",
  READY = "ready",
  ERROR = "error",
}

type AuthState = {
  status: AuthStatus;
  isAuthenticated: boolean;

  uid: string | null;
  email: string | null;
  displayName: string | null;
  role: "tenant";
  claims: null;

  tenant: null;
  availableTenants: null;

  error: null;
};

export interface AuthContext {
  auth: AuthProp;
  updateAuth: (auth: Record<string, unknown>) => void;
  hasValidMembership: (requiredPermissionRank?: number | string) => boolean;
  hasValidRole: (requiredPermissionRank?: number) => boolean;
  needsTenantSelection: boolean;
  selectTenant: (tenant: string) => void;
  refreshClaims: ({
    forceRefresh,
  }: {
    forceRefresh?: boolean;
  }) => Promise<AuthState>;
  setOnboardingMode: (mode: string) => void;
}

export interface AuthProp {
  role?: string;
  [key: string]: unknown;
  tenant: string | null;
  availableTenants?: string[];
  email?: string;
  claims?: Record<string, unknown>;
}
